import { Injectable, signal } from '@angular/core';

/**
 * Bruggetje tussen het user-menu ("Applicatie-instellingen") en het
 * settings-paneel van de chart-omgeving (docs/MOBIEL.md finetune 2026-09-15):
 * het menu-item vraagt het openen aan; de chart-pagina consumeert het verzoek
 * bij init of terwijl hij al open staat. Bewust in core zodat platform-core
 * (user-indicator) niet op human-design hoeft te leunen.
 */
@Injectable({ providedIn: 'root' })
export class AppSettingsPanelService {
  private readonly pendingOpenSignal = signal(false);
  private readonly availableSignal = signal(false);

  /** Openstaand verzoek om het applicatie-instellingenpaneel te tonen. */
  readonly pendingOpen = this.pendingOpenSignal.asReadonly();

  /**
   * Of er in de huidige context een applicatie-instellingenpaneel beschikbaar
   * is. De HD-app-shell zet dit op `true` zolang hij gemount is (dus overal
   * binnen de HD-app) en op `false` bij vernietiging. Het user-menu toont het
   * "Applicatie-instellingen"-item enkel wanneer dit `true` is, zodat het
   * uitsluitend binnen de betreffende app verschijnt.
   */
  readonly available = this.availableSignal.asReadonly();

  requestOpen(): void {
    this.pendingOpenSignal.set(true);
  }

  /** De consument (de app-shell) meldt dat het verzoek verwerkt is. */
  clearPending(): void {
    this.pendingOpenSignal.set(false);
  }

  /** De app-shell registreert/deregistreert de beschikbaarheid van het paneel. */
  setAvailable(available: boolean): void {
    this.availableSignal.set(available);
  }
}
